<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <!-- Filtros -->
    <v-expand-transition>
      <v-layout row wrap align-center v-show="!totalSelected">
        <v-flex xs12 md5>
          <SelectCreditors
            :active="true"
            :multiple="false"
            :selected="idCredor"
            @selectedCreditors="idCredor = $event"
          />
        </v-flex>
        <v-flex xs12 md4>
          <v-switch
            hide-details
            class="pa-0 ma-0"
            label="Mostrar os arquivados"
            v-model="filed"
          ></v-switch>
        </v-flex>
        <v-flex xs12 md3>
          <v-menu offset-y full-width min-width="290px">
            <v-text-field
              box
              readonly
              hide-details
              label="Mês"
              slot="activator"
              :value="monthYear.split('-').reverse().join('/')"
            />
            <v-date-picker
              locale="br"
              type="month"
              class="mt-1"
              v-model="monthYear"
            />
          </v-menu>
        </v-flex>
      </v-layout>
    </v-expand-transition>
    <!-- Botão para arquivar todos -->
    <v-expand-transition>
      <v-layout row wrap v-show="totalSelected">
        <v-flex xs12 style="display: flex; align-items: center">
          <v-btn
            value="notify"
            color="accent"
            style="border-radius: 5px"
            @click="toFileAllSelected"
            >Arquivar selecionados</v-btn
          >
          <span class="font-weight-medium subheading" v-if="totalSelected"
            >{{ totalSelected }}
            {{ totalSelected == 1 ? "Selecionado" : "Selecionados" }}</span
          >
          <v-btn
            flat
            icon
            large
            class="my-0 py-0"
            color="accent"
            @click="clearAllSelected"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-expand-transition>

    <!-- Cards -->
    <v-layout row wrap justify-center>
      <!-- Data/Credor -->
      <v-flex xs12 md2>
        <v-card
          dark
          style="min-height: 130px"
          color="purple darken-4"
          class="elevation-1"
        >
          <v-card-title primary-title class="py-2">
            <div>
              <h3 class="headline">
                {{ monthYear.split("-").reverse().join("/") }}
              </h3>
              <div>{{ nameCreditor }}</div>
            </div>
          </v-card-title>
          <v-card-title v-if="idCredor && monthYear === currentMonthYear && totalAvailableBudget" primary-title class="py-2">
            <div>
              <div class="text-md">
                {{ totalAvailableBudget | numeral("$0,0.00") }}
              </div>
              <div>Orçamento disponível hoje</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <!-- Dias de Produção -->
      <v-flex xs12 md2>
        <v-card
          dark
          style="min-height: 130px"
          color="deep-purple darken-4"
          class="elevation-1"
        >
          <v-card-title primary-title class="py-2">
            <div>
              <h3 class="headline">{{ productionDays }}</h3>
              <div>Dias de Produção</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <!-- Orçamento -->
      <v-flex xs12 md2>
        <v-card
          dark
          style="min-height: 130px"
          color="blue darken-4"
          class="elevation-1"
        >
          <v-card-title primary-title class="py-2">
            <div>
              <h3 class="headline">{{ totalBudget | numeral("$0,0.00") }}</h3>
              <div>Orçamento</div>
            </div>
          </v-card-title>
          <v-card-title primary-title class="py-2">
            <div>
              <div class="text-md">
                {{ totalTreatmentBudget | numeral("$0,0.00") }}
              </div>
              <div>Tratamento</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <!-- Produção -->
      <v-flex xs12 md2>
        <v-card
          dark
          style="min-height: 130px"
          color="cyan darken-4"
          class="elevation-1"
        >
          <v-card-title primary-title class="py-2">
            <div>
              <h3 class="headline">{{ totalProduction | numeral("0,0") }}</h3>
              <div>Produção</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <!-- CPP -->
      <v-flex xs12 md2>
        <v-card
          dark
          style="min-height: 130px"
          color="teal darken-4"
          class="elevation-1"
        >
          <v-card-title primary-title class="py-2">
            <div>
              <h3 class="headline">
                {{ (totalBudget / totalProduction) | numeral("$0,0.00") }}
              </h3>
              <div>CPP</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Tabela -->
    <v-layout row wrap class="mt-1">
      <ShowForecast
        ref="dataTable"
        :filed="filed"
        :esperar="esperar"
        :credores="credores"
        :dias_orcados="lines"
        :ano_mes="monthYear.split('-')"
        :selectedCreditor="nameCreditor == '-' ? false : true"
        @incluir_revisao="criar_revisao"
        @totalSelected="totalSelected = $event"
        @arquivar_orcamento="arquivar_orcamento"
        @orcamentoAdicional="orcamentoAdicional"
        v-if="lines.length !== 0"
      />
    </v-layout>

    <v-speed-dial
      fixed
      bottom
      transition="scale-transition"
      :right="$vuetify.breakpoint.mdAndUp"
      :direction="$vuetify.breakpoint.mdAndUp ? 'left' : 'top'"
      v-model="fab"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="accent" dark fab :disabled="!idCredor">
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-btn
        dark
        round
        class="text-xs-left"
        :key="key"
        :color="tab.color"
        @click="handleModal(tab.treatment)"
        v-for="(tab, key) in fabButtons"
      >
        {{ tab.name }}
      </v-btn>
    </v-speed-dial>

    <v-dialog
      scrollable
      max-width="850px"
      min-height="500px"
      :persistent="true"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialogGerarNotificacao"
    >
      <GenerateForecastModal
        :esperar="esperar"
        :open="dialogGerarNotificacao"
        :nome_credor="nameCreditor"
        :total_gasto_mes="totalBudget"
        :ano_mes="monthYear.split('-')"
        :total_producao_mes="totalProduction"
        @salvar="criar_orcamento"
        @closeDialog="dialogGerarNotificacao = false"
      />
    </v-dialog>

    <v-dialog
      scrollable
      max-width="400px"
      min-height="500px"
      :persistent="true"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialogGerarTratamento"
    >
      <GenerateTreatmentModal
        :esperar="esperar"
        :open="dialogGerarTratamento"
        :nome_credor="nameCreditor"
        :total_gasto_mes="totalBudget"
        :ano_mes="monthYear.split('-')"
        @salvar="criar_orcamento_tratamento"
        @closeDialog="dialogGerarTratamento = false"
      />
    </v-dialog>

    <AditionalForecastModal
      v-model="dialogAditional"
      @salvar="salvarOrcamentoAdicional"
      @close="fecharOrcamentoAdicional"
    />
  </v-container>
</template>

<script>
import store from "@/store";
import CreditorService from "@/services/creditor";
import ForecastService from "@/services/forecast";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import ShowForecast from "@/views/administration/forecast_components/ShowForecast";
import GenerateForecastModal from "@/views/administration/forecast_components/GenerateForecastModal";
import GenerateTreatmentModal from "@/views/administration/forecast_components/GenerateTreatmentModal";
import AditionalForecastModal from "@/views/administration/forecast_components/AditionalForecastModal";

export default {
  components: {
    ShowForecast,
    SelectCreditors,
    GenerateForecastModal,
    GenerateTreatmentModal,
    AditionalForecastModal,
  },
  data() {
    return {
      monthYear: new Date().toISOString().slice(0, 7),
      currentMonthYear: new Date().toISOString().slice(0, 7),
      totalAvailableBudget: 0.0,
      filed: false,
      dialogGerarNotificacao: false,
      dialogGerarTratamento: false,
      dialogAditional: false,
      totalSelected: 0,
      idCredor: "",
      lines: [],
      credores: [],
      esperar: false,
      fab: false,
      selectedForecast: null,
      fabButtons: [
        {
          name: "Tratamento",
          color: "orange",
          treatment: true,
        },
        {
          name: "Notificação",
          color: "red",
          treatment: false,
        },
      ],
    };
  },
  created() {
    CreditorService.list({ active: true }).then((resp) => {
      this.credores = [...resp.objects];
    });

    var query = this.getQuery();
    if (Object.keys(query).length) {
      if (query.data) this.monthYear = query.data;
      if (query.credor) this.idCredor = query.credor;
    }

    this.getData();
  },
  computed: {
    nameCreditor() {
      if (!this.credores.length) return "-";
      if (isNaN(this.idCredor) || this.idCredor === "") return "-";
      let creditor = this.credores.find((c) => c.creditor_id == this.idCredor);
      return Object.keys(creditor).length && creditor.name
        ? creditor.name
        : "-";
    },
    productionDays() {
      var cont = 0;
      if (this.lines.length) {
        var daysChecks = [];
        this.lines.forEach((line) => {
          if (line.budget) {
            if (daysChecks.indexOf(line.day) === -1) {
              daysChecks.push(line.day);
              cont++;
            }
          }
        });
      }
      return cont;
    },
    totalBudget() {
      if (this.lines.length)
        return this.lines.reduce((p, c) => c.budget + p, 0);
      return 0;
    },
    totalTreatmentBudget() {
      if (this.lines.length) {
        const treatments = this.lines.filter(
          (l) => l.type === "LEMMIT_TREATMENT"
        );
        return treatments.reduce((p, c) => c.budget + p, 0);
      }
      return 0;
    },
    totalProduction() {
      if (this.lines.length) return this.lines.reduce((p, c) => c.goal + p, 0);
      return 0;
    },
  },
  watch: {
    monthYear() {
      this.getData();
    },
    idCredor() {
      this.getData();
    },
  },
  methods: {
    /**
     * Carrega a query.
     *
     * @returns Retorna um objeto com os filtros da url.
     */
    getQuery() {
      let query = this.$route.query;
      if (query && !Object.keys(query).length) {
        query = store.getters.getForecastsFilters;
      }
      return { ...query };
    },

    handleModal(treatment) {
      if (treatment) {
        this.dialogGerarTratamento = true;
        return;
      }
      this.dialogGerarNotificacao = true;
    },

    getData() {
      this.addfilters();
      if (isNaN(this.idCredor) || this.idCredor === "") {
        this.all();
      } else {
        this.byCreditor();
      }
    },

    all() {
      ForecastService.findByMonth(
        this.monthYear.split("-")[1],
        this.monthYear.split("-")[0]
      )
        .then((resp) => {
          this.lines = resp.objects.slice();
        })
        .catch((error) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao obter os dados deste mês, tente novamente em breve."
          );
          console.error(error);
        });
    },

    byCreditor() {
      ForecastService.findByCreditorMonth(
        this.idCredor,
        this.monthYear.split("-")[1],
        this.monthYear.split("-")[0]
      )
        .then((resp) => {
          this.lines = resp.objects.slice();
          this.totalAvailableBudget = 0.0;
          if (this.lines && this.lines.length && this.monthYear === this.currentMonthYear) {
            const item = this.lines.find((l) => l.available_budget)
            this.totalAvailableBudget = item ? (item.available_budget || 0.0) : 0.0;
          }
        })
        .catch((erro) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao obter os dados deste mês, tente novamente em breve."
          );
        });
    },

    clearAllSelected() {
      this.$refs.dataTable.clearAllSelected();
    },

    toFileAllSelected() {
      this.$refs.dataTable.toFileAllSelected();
    },

    setar_filtros_url() {
      const filtros = this.$store.getters.getForecastsFilters;
      if (filtros.credor) {
        this.$router.replace({
          name: "Previsão mensal por credor",
          query: filtros,
        });
      } else {
        this.$router.replace({
          name: "Previsão mensal por credor",
          query: { data: filtros.data },
        });
      }
    },

    addfilters() {
      let query = {};
      if (this.idCredor) query.credor = this.idCredor;
      if (this.monthYear) query.data = this.monthYear;
      this.$store.commit("setForecastsFilters", query);
      if (this.$route.path == "/administration-forecast") {
        this.$router.replace({
          name: "Previsão mensal por credor",
          query: query,
        });
      }
    },

    pegar_dias: function () {
      this.$store.commit("setForecastsFilters", {
        credor: this.idCredor,
        data: this.monthYear,
      });
      this.setar_filtros_url();

      const self = this;
      ForecastService.findByCreditorMonth(
        this.idCredor,
        this.monthYear.split("-")[1],
        this.monthYear.split("-")[0]
      )
        .then(({ objects }) => {
          if (objects.length === 0) {
            this.dialogGerarNotificacao = true;
          }
          self.lines = objects;
          self.esperar = false;
        })
        .catch((erro) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao obter os dados deste mês, tente novamente em breve."
          );
          self.esperar = false;
        });
    },

    criar_orcamento: function (novo_mes) {
      this.dialogGerarNotificacao = false;
      this.esperar = true;
      const self = this;
      const currentUser = store.getters.getLoggedUser;
      let dados = novo_mes.map((d) => {
        return {
          creditor_id: this.idCredor,
          day: this.monthYear + "-" + d.dia,
          budget: d.budget,
          goal: d.goal,
          last_updated_by: currentUser.name,
          type: "NOTIFICATION",
        };
      });
      ForecastService.createForecastMonth(dados)
        .then((retorno) => {
          self.pegar_dias();
          this.$store.commit("showSnackbar", "Orçamento criado com sucesso!");
        })
        .catch((erro) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao salvar. Confira seus dados!"
          );
          self.esperar = false;
        });
    },

    criar_orcamento_tratamento: function (novo_mes) {
      this.esperar = true;
      const self = this;
      const currentUser = store.getters.getLoggedUser;

      let dados = novo_mes.map((d) => {
        return {
          creditor_id: this.idCredor,
          day: this.monthYear + "-" + d.dia,
          budget: d.budget,
          goal: d.goal,
          last_updated_by: currentUser.name,
          type: "LEMMIT_TREATMENT",
        };
      });

      ForecastService.createForecastMonth(dados)
        .then(() => {
          self.pegar_dias();
          this.$store.commit("showSnackbar", "Orçamento criado com sucesso!");
          this.dialogGerarTratamento = false;
        })
        .catch((erro) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao salvar. Confira seus dados!"
          );
          self.esperar = false;
        });
    },

    criar_revisao(alteracoes, dia_id) {
      const self = this;
      this.esperar = true;
      ForecastService.updateForecast(alteracoes, dia_id)
        .then((retorno) => {
          self.lines.map((d, index) => {
            if (d.id === dia_id) {
              self.$set(self.lines, index, retorno);
            }
          });
          this.getData();
          self.esperar = false;
        })
        .catch((erro) => {
          self.esperar = false;
          self.$store.commit(
            "showSnackbar",
            "Falha ao alterar registro. Confira seus dados e tente novamente!"
          );
        });
    },

    arquivar_orcamento(dia_id) {
      const self = this;
      ForecastService.removerForecast(store.getters.getLoggedUser.name, dia_id)
        .then((retorno) => {
          self.lines.map((d, index) => {
            if (d.id === dia_id) {
              self.$set(self.lines, index, retorno);
            }
          });
        })
        .catch((err) => {
          self.$store.commit(
            "showSnackbar",
            "Falha ao tentar arquivar este item."
          );
          console.error(err);
        });
    },

    orcamentoAdicional(forecast) {
      this.dialogAditional = true;
      this.selectedForecast = forecast;
    },

    salvarOrcamentoAdicional(valor) {
      const id = parseInt(this.selectedForecast.id.match(/\d+/)[0], 10) // removendo "soma_" da frente do id

      const params = {
        forecast_id: id,
        additional_value: valor,
      }

      ForecastService.addAdditionalForecast(params)
        .then(() => {
          this.$store.commit(
            "showSnackbar",
            "Orçamento adicional salvo com sucesso."
          );
          this.getData();
        })
        .catch((e) => {
          console.error('Erro ao salvar orçamento adicional:', e);
          this.$store.commit(
            "showSnackbar",
            "Falha ao salvar orçamento adicional."
          );
        });
    },

    fecharOrcamentoAdicional() {
      this.dialogAditional = false;
      this.diaSelecionado = null;
    },
  },
};
</script>
